import axios from 'axios';
import config from '../../config';

// create new axios instance
const _axios = axios.create({
    baseURL: config.url,
});

_axios.interceptors.request.use((config_axios) => {
    const current_region_url = sessionStorage.current_region_url;
    if(current_region_url && current_region_url){
        config_axios.baseURL = current_region_url;
    } else {
        config_axios.baseURL = config.url;
    }


    if(config_axios.url.includes('service_region')){
        config_axios.baseURL = config.service_region_url;
    }

    if(localStorage.token){
        config_axios.headers.Authorization = `Bearer ${localStorage.token}`;
    }

    if(sessionStorage.token){
        config_axios.headers.Authorization = `Bearer ${sessionStorage.token}`;
    }
    if(sessionStorage.role && sessionStorage.view_type) {
        config_axios.headers.role = sessionStorage.role;
        config_axios.headers['view-type'] = sessionStorage.view_type;
    }
    config_axios.headers.dashboard_url = window.location && window.location.href ? window.location.href : "Admin Panel" ;
    return config_axios;
}, (error) => {
    return Promise.reject(error);
});

_axios.interceptors.response.use((response) => {
    if(response && response.status === 201 && response.data && response.data.sso_url){ 
        window.location.href = response.data.sso_url;
    }
    if(response && response.status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/'; 
    }
    else {
        return response;
    }
}, (error) => {
    return Promise.reject(error);
});
        
export default _axios;